export const BASE_URL = "https://waiz-kw.com";
export const APP_PREFIX_PATH = "/2024/clinic/admin";

export const API_URL = `${BASE_URL}/2024/clinic/server/admin`;

export function getApiMessage(data, langCode = "en") {
  if (!data || data.msg == null) return "";
  const msg = data.msg;
  if (Array.isArray(msg)) {
    const i = langCode === "ar" ? 1 : 0;
    return msg[i] || msg[0] || msg[1] || "";
  }
  return String(msg);
}
